import React from 'react';
import * as styles from 'src/uglib_styles/a11yMessage.module.css'

function A11yMessage (props) {
	
	return (<>
		<div id={styles.accessibility_message}>
			<span className="icon fa-regular fa-info"></span>
			<span className={styles.message}>The library is committed to ensuring that members of our user community with disabilities have equal access to our services and resources and that their dignity and independence is always respected. If you encounter a barrier and/or need an alternate format, please fill out our <a href="/about/policies/accessibility-policies/library-resource-accessibility-policy/alternate-format-request-form">Library Print and Multimedia Alternate-Format Request Form</a>. Contact us if you’d like to provide feedback: <a href="mailto:lib.a11y@uoguelph.ca">lib.a11y@uoguelph.ca </a></span>
		</div>
	</>)
	
}

export default A11yMessage